<template>
    <OverlayLoader :isLoading="!connectionsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.connections')"
                />

                <WhiteTable @changePage="changePage" :showPaginate="true" :paginate="paginate" :labels="[$translate.text('clients.connections.name'), $translate.text('clients.connections.webshop'), $translate.text('clients.connections.feed'), $translate.text('clients.connections.status')]">
                    <template slot="table-data">
                        <tr v-for="(connection ,index ) in connections" :key="index">
                            <td>{{ connection.name }}</td>
                            <td>{{ connection.webshop_name }}</td>
                            <td>{{ connection.feed_name }}</td>
<!--                            <td v-if="connection.syncActive">-->
<!--                                {{ $translate.text(`clients.connections.status.${connection.status}`) }}-->
<!--                            </td>-->
                            <td v-if="connection.status">
                                {{ $translate.text(`clients.connections.status.${connection.status}`) }}
                            </td>
                            <td v-else>-</td>
                            <!-- <td> -->
                            <!--<i class="fal fa-folder-tree" v-tooltip.bottom="$translate.text('clients.connections.categories')"></i>-->
                            <!--<i class="fal fa-industry" v-tooltip.bottom="$translate.text('clients.connections.brands')"></i>-->
                            <!--<i class="fal fa-random" v-tooltip.bottom="$translate.text('clients.connections.attributes')"></i>-->
                            <!--<i class="fal fa-money-check-alt" v-tooltip.bottom="$translate.text('clients.connections.pricing')"></i>-->
                            <!-- </td> -->
                            <td class="align-right">
                                <i class="fal fa-boxes" @click="$router.push({ name: 'Clients Connections Products', params: { id: connection.id } })" v-tooltip.bottom="$translate.text('tooltip.all_products')"></i>
                                <i class="fal fa-sync" :class="{'sync-active' : connection.syncActive}" v-if="connection.active" v-tooltip.bottom="$translate.text('tooltip.sync')" @click="syncConnection(connection.id, connection.syncActive, connection.dryrun)"></i>
                                <i class="fal fa-edit" @click="$router.push({ name: 'Clients Connections Edit', params: { id: connection.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                <i class="fal fa-trash-alt" @click="deleteConnection(connection.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                                <i class="fal fa-info" v-tooltip.left="`${$translate.text('tooltip.last_sync')}: <br> ${connection.last_sync} <hr> ${$translate.text('tooltip.last_update')}: <br> ${connection.last_update}`"></i>
                            </td>
                        </tr>
                        <tr v-if="!connections.length">
                            <td colspan="6">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>
            <div style="position:absolute; right:40px; bottom:90px; display:flex; flex-direction:column; align-items:center;">
                <SyncButton @clicked="clicked" v-if="syncItemsLoaded && syncItems.length > 0 ">
                    <div class="sync-popup" :class="{'sync-show-fade': showSyncPop}" style="padding:8px;">
                        <div class="close" style="right: 5px; top: 5px; position: absolute; cursor: pointer;" ><i @click="clicked" class="fal fa-times-circle" style="font-size:16px;" /></div>
<!--                        <div class="sync-content" v-for="(item,index) in syncItems" :key="index">-->
<!--                            <div class="sync-item-header"><i class="fal fa-sync" style="font-size:16px; margin-right: 4px;" /> {{ getSyncTypeText(item.sync_type) }} {{item.shop_name}} {{item.name}}</div>-->
<!--                            <div class="sync-item-content">-->
<!--                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">-->
<!--                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">-->
<!--                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${item.product_feed_progress}%`}"></div>-->
<!--                                    </div>-->
<!--                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.product_feed_progress_count}} / {{item.product_feed_count}} {{$translate.text('clients.connections.status.product_feed')}}</div>-->
<!--                                </div>-->
<!--                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">-->
<!--                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">-->
<!--                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${item.collectable_progress}%`}"></div>-->
<!--                                    </div>-->
<!--                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.collectable_progress_count}} / {{item.collectable_count}} {{$translate.text('clients.connections.status.product_feed.preparing')}}</div>-->
<!--                                </div>-->
<!--                                <div v-if="item.cp_active" class="col-sm grey-bg" style="display:flex; margin:12px 0px;">-->
<!--                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">-->
<!--                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${item.collectable_cp_progress}%`}"></div>-->
<!--                                    </div>-->
<!--                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.collectable_cp_progress_count}} / {{item.collectable_cp_count}} {{$translate.text('clients.connections.status.product_feed.content_provider')}}</div>-->
<!--                                </div>-->
<!--                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">-->
<!--                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">-->
<!--                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${item.sync_progress}%`}"></div>-->
<!--                                    </div>-->
<!--                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.sync_progress_count}} / {{item.sync_count}} {{$translate.text('clients.connections.status.product_feed.webshop')}}</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <hr v-if="index != syncItems.length -1">-->
<!--                        </div>-->

                        <div class="sync-content" v-for="(item,index) in syncItems" :key="index">
                            <div class="sync-item-header"><i class="fal fa-sync" style="font-size:16px; margin-right: 4px;" /> {{ getSyncTypeText(item.sync_type) }} {{item.shop_name}} {{item.name}}</div>
                            <div class="sync-item-content">
                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;" v-if="item.downloadable > 0">
                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${calculatePercentage(item.downloaded, item.downloadable)}%`}"></div>
                                    </div>
                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.downloaded}} / {{item.downloadable}} {{$translate.text('clients.connections.status.product_feed.downloading')}}</div>
                                </div>
                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">
                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${calculatePercentage(item.collectable, item.total)}%`}"></div>
                                    </div>
                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.collectable}} / {{item.total}} {{$translate.text('clients.connections.status.product_feed.reading')}}</div>
                                </div>
                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">
                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${calculatePercentage(item.collected, item.total)}%`}"></div>
                                    </div>
                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.collected}} / {{item.collectable}} {{$translate.text('clients.connections.status.product_feed.collecting')}}</div>
                                </div>
                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">
                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${calculatePercentage(item.synced, item.syncable)}%`}"></div>
                                    </div>
                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.synced}} / {{item.syncable}} {{$translate.text('clients.connections.status.product_feed.syncing')}}</div>
                                </div>
                                <div class="col-sm grey-bg" style="display:flex; margin:12px 0px;">
                                    <div class="timespan-stroke" style="width:20%; height:3px; background-color: #CBD5E0; margin-top: 8px; position:relative;">
                                        <div class="temp-stroke" style="height:3px; position:absolute; background-color:#86DEB7;" :style="{width: `${calculatePercentage(item.deleted, item.deletable)}%`}"></div>
                                    </div>
                                    <div class="days-remaining" style="width:80%; margin-left:8px;">{{item.deleted}} / {{item.deletable}} {{$translate.text('clients.connections.status.product_feed.deleting')}}</div>
                                </div>
                            </div>
                            <hr v-if="index != syncItems.length -1">
                        </div>
                    </div>
                </SyncButton>
                <FloatingButton
                    @clicked="$router.push({ name: 'Clients Connections Add' })"
                    :customPosition="true"
                />
            </div>

        </main>
    </OverlayLoader>
</template>
<script>

import swal from 'sweetalert';
import { setTimeout } from 'timers';

import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';
import SyncButton from '@/components/FloatingButton/SyncButton';


export default {
    name: 'ClientsConnections',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
        SyncButton,
    },

    data() {
        return {
            connections: [],
            connectionsLoaded: false,
            showSyncPop: false,

            syncItems: [],
            syncItemsLoaded: false,

            paginate: {
                current_page: 1,
            },
        };
    },

    created() {
        this.getConnections();
        this.getSyncData();
    },

    computed: {
        connectionIds() {
            return this.connections.map(item => item.id);
        },
    },

    methods: {
        clicked() {
            this.showSyncPop = !this.showSyncPop;
        },

        checkStillSync(connection) {
            let bool = false;
            this.syncItems.forEach(syncItem => {
                if (syncItem.id === connection.id) {
                    bool = true;
                }
            });
            return bool;
        },

        changePage(value) {
            switch (value) {
            case 'next':
                this.paginate.current_page += 1;
                break;
            case 'previous':
                this.paginate.current_page -= 1;
                break;
            default:
                this.paginate.current_page = value;
            }

            this.getConnections();
        },

        getConnections() {
            this.connectionsLoaded = false;
            this.API.clients.connections.index(this.paginate.current_page)
                .then((response) => {
                    const data = response.data.data;
                    this.paginate = response.data.meta;
                    data.forEach(item => {
                        if (item.status === 'queue' || item.status === 'syncing') {
                            item.syncActive = true;
                        } else {
                            item.syncActive = false;
                        }
                    });
                    this.connections = data;
                    this.connectionsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getStatus(connection) {
            if (this.syncItems.length === 0) {
                connection.status = null;
            }

            this.syncItems.forEach(item => {
                if (item.id === connection.id) {
                    connection.status = item.status;
                } else if (!this.connectionIds.includes(item.id)) {
                    console.log('set to null');
                }
            });

            setTimeout(() => {
                this.getStatus(connection);
            }, 3000);
        },

        getSyncData() {
            if (this.$route.name === 'Clients Connections') {
                this.API.clients.connections.syncData()
                    .then((response) => {
                        this.syncItems = response.data.data;

                        this.connections.forEach(connection => {
                            connection.syncActive = false;

                            this.syncItems.forEach(syncItem => {
                                if (connection.id === syncItem.id) {
                                    connection.status = syncItem.status;

                                    if (connection.status === 'queue' || connection.status === 'syncing') {
                                        connection.syncActive = true;
                                    } else {
                                        connection.syncActive = false;
                                    }
                                }
                            });
                        });

                        this.syncItemsLoaded = true;
                        setTimeout(() => {
                            this.getSyncData();
                        }, 3000);
                    })
                    .catch((error) => {
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                        setTimeout(() => {
                            this.getSyncData();
                        }, 3000);
                    });
            }
        },

        syncConnection(id, syncActive, dryRun) {
            let swallMessage = this.$translate.text('alert.confirm.start_synchronisation');

            if (dryRun && syncActive) {
                swallMessage = this.$translate.text('alert.confirm.active_start_dryrun');
            } else if (dryRun) {
                swallMessage = this.$translate.text('alert.confirm.start_dryrun');
            } else if (syncActive) {
                swallMessage = this.$translate.text('alert.confirm.active_start_synchronisation');
            }
            swal(
                swallMessage,
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('alert.confirm.full_sync'),
                        changes: this.$translate.text('alert.confirm.only_feed_changes'),
                        // dryrun: this.$translate.text('alert.confirm.dry_run'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.clients.connections.sync(id, value === true ? 'full' : 'changes')
                        .then(() => {
                            this.getConnections();
                            swal({
                                title: this.$translate.text('alert.success'),
                                text: this.$translate.text('alert.success.message.synchronisation_started'),
                            });
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        deleteConnection(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.clients.connections.destroy(id)
                        .then(() => {
                            this.getConnections();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        getSyncTypeText(type) {
            if (type === 'full') {
                return `${this.$translate.text('clients.connections.status.synchronizing')}:`;
            }
            if (type === 'update') {
                return `${this.$translate.text('clients.connections.status.updating')}:`;
            }
            return '';
        },

        calculatePercentage(value1, value2) {
            if (value1 === 0 || value2 === 0) {
                return 0;
            }

            return parseInt(value1 / (value2 / 100), 0);
        },
    },
};
</script>
<style lang="scss" scoped>
.sync-popup {
    border: 1px solid #607A93;
    position: absolute;
    border-radius: 8px;
    right:0px;
    // padding:0 8px 0 8px;
    width:500px;
    bottom:150px;
    max-height: 305px;
    overflow: auto;
    background-color:white;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.5s, opacity 0.5s linear;
}
.sync-active {
    -webkit-animation:spin 1.5s linear infinite;
    -moz-animation:spin 1.5s linear infinite;
    animation:spin 1.5s linear infinite;
}
.temp-stroke {
    transition: width 200ms ease-in-out;
}

@-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
@-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
@keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }

.sync-show-fade {
    visibility: visible;
  opacity: 1;
  transition: opacity 0.5s linear;
}

hr {
    border: 1px solid #dedede;
}
td {
    width: 20%;
}
</style>
